export default __webpack_public_path__ + "static/media/a028-1.00be3fd8.svg";